import { useScrollReveal } from '@/hooks/useScrollReveal';

const comments = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20male%20character%20portrait%2C%20dark%20hair%2C%20simple%20expression%2C%20clean%20minimal%20background%2C%20headshot%20style&width=120&height=120&seq=avatar-01&orientation=squarish',
    name: '暗夜旅人',
    time: '2 小时前',
    work: '《深渊之触》第 187 话',
    text: '这一话的分镜简直绝了！海底遗迹的触手生物设计太有想象力了，作者对异形美学的把控越来越成熟。强烈推荐给所有喜欢触手题材的读者！',
    likes: 342,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20female%20character%20portrait%2C%20simple%20clean%20expression%2C%20headshot%2C%20minimal%20background&width=120&height=120&seq=avatar-02&orientation=squarish',
    name: '星辰之海',
    time: '5 小时前',
    work: '《异种学院》第 203 话',
    text: '最终试炼篇的展开太精彩了，每个角色的触手能力进化都让人眼前一亮。学院篇一直都是我最喜欢的触手漫画，没有之一！',
    likes: 278,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20character%20portrait%2C%20cool%20expression%2C%20headshot%20style%2C%20minimal%20clean%20background&width=120&height=120&seq=avatar-03&orientation=squarish',
    name: '墨染清秋',
    time: '8 小时前',
    work: '《星海迷踪》第 148 话',
    text: '触手文明的语言交流设计真的惊艳到我了，不是传统的战斗而是沟通和理解，这种触手漫画的叙事方式太独特了。',
    likes: 195,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20character%20headshot%2C%20thoughtful%20expression%2C%20clean%20minimal%20background%2C%20portrait&width=120&height=120&seq=avatar-04&orientation=squarish',
    name: '幻影流年',
    time: '12 小时前',
    work: '《触手纪元》全集',
    text: '终于等到精校版了！312 话一气呵成读完，触手纪元的世界观设定放到现在依然是触手漫画题材的巅峰之作。',
    likes: 521,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20character%20headshot%20portrait%2C%20simple%20expression%2C%20minimal%20background%2C%20clean%20style&width=120&height=120&seq=avatar-05&orientation=squarish',
    name: '风起云涌',
    time: '1 天前',
    work: '《星域触手姬》首话',
    text: '新作开局就很抓人！科幻背景下的触手设定非常有新意，三连更的节奏也很舒服。期待后续发展，已加入追更列表！',
    likes: 167,
  },
];

export default function CommentsSection() {
  const { ref: titleRef, visible: titleVisible } = useScrollReveal(0.12);

  return (
    <section id="comments" className="py-16 md:py-24 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div ref={titleRef} className={`text-center mb-12 ${titleVisible ? 'animate-fade-in-up' : 'animate-initial-hidden'}`}>
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100/60 border border-accent-200/50 mb-4">
            <i className="ri-chat-heart-line text-accent-600 text-xs w-4 h-4 flex items-center justify-center"></i>
            <span className="text-xs font-medium text-accent-700 whitespace-nowrap">真实读者反馈</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            读者热评
          </h2>
          <div className="w-16 h-0.5 bg-primary-500 mx-auto mb-4"></div>
          <p className="text-sm md:text-base text-foreground-600">
            触手漫画读者的真实声音，一起分享阅读的快乐
          </p>
        </div>

        <div className="space-y-5">
          {comments.map((comment, idx) => (
            <CommentItem key={idx} comment={comment} idx={idx} />
          ))}
        </div>
      </div>
    </section>
  );
}

function CommentItem({ comment, idx }: { comment: typeof comments[0]; idx: number }) {
  const { ref, visible } = useScrollReveal(0.06);

  return (
    <div
      ref={ref}
      className={`bg-background-50 rounded-lg p-5 border border-background-200/60 hover:border-background-300/60 transition-colors ${
        visible ? `animate-fade-in-up animate-stagger-${idx + 1}` : 'animate-initial-hidden'
      }`}
    >
      <div className="flex items-start gap-4">
        <img
          src={comment.avatar}
          alt={comment.name}
          className="w-10 h-10 rounded-full object-cover flex-shrink-0"
        />
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 flex-wrap">
            <span className="text-sm font-semibold text-foreground-900 whitespace-nowrap">
              {comment.name}
            </span>
            <span className="text-xs text-foreground-500 whitespace-nowrap">{comment.time}</span>
            <span className="text-xs text-accent-600 bg-accent-100 px-2 py-0.5 rounded whitespace-nowrap">
              {comment.work}
            </span>
          </div>
          <p className="text-sm text-foreground-700 mt-2 leading-relaxed">{comment.text}</p>
          <div className="flex items-center gap-4 mt-3">
            <button className="flex items-center gap-1 text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
              <i className="ri-thumb-up-line w-3.5 h-3.5 flex items-center justify-center"></i>
              {comment.likes}
            </button>
            <button className="flex items-center gap-1 text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
              <i className="ri-chat-1-line w-3.5 h-3.5 flex items-center justify-center"></i>
              回复
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}